const apiBaseUrl =  'https://apis.footplayhd.com'
const imageBaseurl =  'https://apis.footplayhd.com/uploads/'
// const apiBaseUrl = 'http://localhost:5000'
// const imageBaseurl = 'http://localhost:5000/uploads/'

const localhostKey = {
  token: 'at'
}

export const siteData = {
  name: "FootPlayHD",
}

const pageRoute = {
  login: "/login",
  signUp: '/sign-up',
  profile: '/profile',
  newsLatter: '/news-latter',
  contactUsList: '/contact-us-list',
  channelManagement: '/channel',
  matchDetails: '/match',
  sliderManagement: '/slider',
}

const getImageFullUrl = (url) => {
  return imageBaseurl + url
}

export {
  apiBaseUrl, imageBaseurl, localhostKey, pageRoute, getImageFullUrl
}